const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.themeVariables.settings.moneyFormat;

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const formatType = match ? match[1] : "amount";
  const value = formatWithDelimiters(cents, formatType.includes("no_decimals") ? 0 : 2, formatType.includes("space_separator") ? " " : formatType.includes("comma_separator") ? "." : formatType.includes("apostrophe_separator") ? "'" : ",", formatType.includes("comma_separator") ? "," : ".");

  return formatString.replace(placeholderRegex, value);
}

(function (cd, fetch) {
  cd.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if (`${window.location.origin}/cart/add.js`.includes(res.url) && res.status === 200) {
        if (!document.querySelector('cart-drawer#cart-drawer').hasAttribute('open')) {
          document.querySelector('a.cart_new.original_cart_trigger').click();
        }
        updateCart();
      }
    });
    return response;
  };
}(window, window.fetch));

function updateCart() {
  fetch('?section_id=cart-drawer')
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cart = doc.querySelector('.cart-drawer');
      const cartDrawer = document.querySelector('.cart-drawer');
      cartDrawer.innerHTML = cart.innerHTML;
      attachEventListeners();
      updateBagCount();
    });
}

function updateBagCount() {
  fetch('?section_id=cart-bag-count')
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cart_bag = doc.querySelector('a.cart_new.original_cart_trigger');
      const cartBagCoount = document.querySelector('a.cart_new.original_cart_trigger');
      const cartBagCoountMobile = document.querySelector('a.mob_cart.original_cart_trigger');
      cartBagCoount.innerHTML = cart_bag.innerHTML;
      cartBagCoountMobile.innerHTML = cart_bag.innerHTML;
    });
}

function attachEventListeners() {
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    const quantityInput = btn.closest('.quantity-wrapper').querySelector('input.quantity-input');
    const line = quantityInput.getAttribute('data-line-key');
    btn.addEventListener('click', () => {
      let quantity = parseInt(quantityInput.value);
      quantity = btn.classList.contains('plus-btn') ? quantity + 1 : Math.max(quantity - 1, 1);
      quantityInput.value = quantity;
      updateCartQuantity(line, quantity);
    });
  });

  document.querySelectorAll('.line-item-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = btn.getAttribute('data-line');
      document.querySelector(`.line-item[data-line="${line}"]`).style.opacity = 0.5;
      document.querySelector(`.line-item[data-line="${line}"]`).insertAdjacentHTML('beforeend', '<div class="cart-item-loader"></div>');
      removeItem(line);
      
    });
  });

  document.querySelectorAll('.add-upsell').forEach(btn => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      let upsellProduct = btn.closest('.upsell-product-item');
      let upsellProductWrapper = upsellProduct.closest('.upsell-product-item-wrapper');
      const variantId = btn.getAttribute('data-variant-id');
      const quantity = 1;
      upsellProduct.style.opacity = 0.5;
      upsellProductWrapper.insertAdjacentHTML('beforeend', '<div class="cart-item-loader"></div>');
      addItemToCart(variantId, quantity);
    });
  });

  document.querySelectorAll('select[name="upsell_variant"]').forEach(select => {
    select.addEventListener('change', () => {
      const variantId = select.value;
      select.nextElementSibling.setAttribute('data-variant-id', variantId);
      select.closest('.upsell-product-item').querySelector('img.feat-img').src = select.querySelector(`option[value="${variantId}"]`).getAttribute('data-featured-image');
    });
  });
}

async function addItemToCart(variantId, quantity) {
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ id: variantId, quantity })
  });
}

async function updateCartQuantity(line, quantity) {
  const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ line, quantity })
  });
  const cartContent = await response.json();
  document.querySelector("#cart-total_price").innerText = formatMoney(cartContent.total_price, currencyFormat);
  let cartItems = cartContent.items;

  for (let i = 0; i < cartItems.length; i++) {
    let lineItem = i + 1;
    console.log(lineItem, line);
    if (lineItem == line) {
      document.querySelector(`line-item.line-item[data-line="${line}"] .line-item__price`).innerText = formatMoney(cartItems[i].line_price, currencyFormat);
    }
  }
  updateBagCount();
}

function removeItem(line) {
  fetch(`${Shopify.routes.root}cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ line, quantity: 0 })
  }).then(() => {
    updateCart();
    updateBagCount();
  });
}

// Initial event listener attachment
attachEventListeners();
